import { Completer } from "./utils/completer";
import { CreateAccountPageController } from "../pages/create_account/create-account-page";
import { ExamplePageController } from "../pages/example_page/example-page";
import { ForumPageController } from "../pages/forum_page/forum_page";
import { ForumPostPageController } from "../pages/forum_post_page/forum_post_page";
import { ForgotPasswordPageController } from "../pages/forgot_password_page/forgot-password-page";
import { HomePageController } from "../pages/home_page/home-page";
import { TabPageController } from "../pages/tab_page/tab-page";
import { TabSubmissionChatPageController } from "../pages/tab_submission_chat_page/tab-submission-chat-page";
import { TabsPageController } from "../pages/tabs_page/tabs-page";
import { ThemeController } from "./theme";
import { LogLevel } from "./utils/log-level";
import { Logger } from "./utils/logger";
import { AlertDialogController } from "../dialogs/alert_dialog/alert_dialog";
import { AdDisplay } from "./web-components/ad-display";
import { AdInArticle } from "./web-components/ad-in-article";
import { AdInFeedTextOnly } from "./web-components/ad-in-feed-text-only";
import { AdMultiplex } from "./web-components/ad-multiplex";
import { AutoCompleteSearch } from "./web-components/auto-complete-search";
import { CircularProgressIndicator } from "./web-components/circular-progress-indicator";
import { CreateTabCommentForm, CreateForumCommentForm } from "./web-components/create-comment-form";
import { AppbarController } from "../widgets/appbar/appbar";
import { AppbarDropdownController } from "../widgets/appbar_dropdown/appbar-dropdown";
import { CommentListController } from "../widgets/comment_list/comment-list";
import { CookieBannerController } from "../widgets/cookie_banner/cookie-banner";
import { LoginDialogController } from "../dialogs/login_dialog/login-dialog";
import { SideNavController } from "../widgets/side_nav/side-nav";
import { TabSubmissionFormController } from "../widgets/tab_submission_form/tab-submission-form";
import { TabTextViewController } from "../widgets/tab_text_view/tab-text-view";

export class AppUrls {
    static home: string;
    static tabs: string;
    static favorites: string;
    static example: string;
    static login: string;
    static logout: string;
    static createAccountEndpoint: string;
    static verifyEmailEndpoint: string;
    static forgotPasswordEndpoint: string;
    static resetPasswordEndpoint: string;
    static createCommentEndpoint: string;
    static tabSubmissions: string;
    static getComposers: string;
    static getGames: string;
    static getInstruments: string;
    static getStyles: string;
    static getUsers: string;
    static getForumPosts: string;
}

export class App {
    static nonce: string | null = null;
    static initializationCompleter = new Completer<null>();
    static loggedIn: boolean = false;
    static mockAds: boolean = false;

    static registerWebComponents(): void {
        customElements.define(CircularProgressIndicator.htmlTag, CircularProgressIndicator);
        customElements.define(AutoCompleteSearch.htmlTag, AutoCompleteSearch);
        customElements.define(CreateTabCommentForm.htmlTag, CreateTabCommentForm);
        customElements.define(CreateForumCommentForm.htmlTag, CreateForumCommentForm);

        // Ads
        customElements.define('ad-display', AdDisplay);
        customElements.define('ad-in-article', AdInArticle);
        customElements.define('ad-in-feed-text-only', AdInFeedTextOnly);
        customElements.define('ad-multiplex', AdMultiplex);
    }

    static initializeApp(): void {
        // Logger.setLogLevel(LogLevel.INFO);
        Logger.setLogLevel(LogLevel.WARN);
        // Logger.setLogLevel(LogLevel.ERROR);
        // MarkdownUtils.logTest();

        // Misc controllers widgets and pages may rely on
        window.themeController = new ThemeController();

        // Dialog controllers
        window.loginDialogController = new LoginDialogController();
        window.alertDialogController = new AlertDialogController();

        // Widget controllers
        window.cookieBannerController = new CookieBannerController();
        window.sideNavController = new SideNavController();
        window.appbarDropdownController = new AppbarDropdownController();
        window.appbarController = new AppbarController();
        window.commentListController = new CommentListController();
        window.tabTextViewController = new TabTextViewController();
        window.tabSubmissionFormController = new TabSubmissionFormController();

        // Page controllers
        window.homePageController = new HomePageController();
        window.forumPageController = new ForumPageController();
        window.forumPostPageController = new ForumPostPageController();
        window.tabsPageController = new TabsPageController();
        window.tabPageController = new TabPageController();
        window.examplePageController = new ExamplePageController();
        window.createAccountPageController = new CreateAccountPageController();
        window.forgotPasswordPageController = new ForgotPasswordPageController();
        window.tabSubmissionChatPageController = new TabSubmissionChatPageController();
        App.initializationCompleter.resolve(null);
    }
}
